import SmartProductCard from "./SmartProductCard";

export default function Carousel({ title, products, onOpen, onAdd,
                                    inWishlist, onToggleWishlist, testid }) {
  if (!products?.length) return null;
  return (
    <section className="hpz-shop__carousel" data-testid={testid}>
      <header><h3>{title}</h3></header>
      <div className="hpz-shop__carousel-track">
        {products.slice(0, 12).map((p) => (
          <div key={p.sku} className="hpz-shop__carousel-item">
            <SmartProductCard
              product={p}
              onOpen={() => onOpen(p.sku)}
              onAdd={() => onAdd(p)}
              inWishlist={inWishlist(p.sku)}
              onToggleWishlist={() => onToggleWishlist(p.sku)}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
